import React, { PureComponent, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import Routes from './routes';
import HeaderDefault from './shared/components/header';
import Footer from './shared/components/footer';
import { ToastProvider } from 'react-toast-notifications';
import Odoo from 'odoo-xmlrpc';
import { OdooConfig } from './utilities/odoo-config';
import { setData } from './services/login.service';
import { Desencrypt } from './utilities/cipher';
import fondo from './assets/fondo.png';

class App extends PureComponent {
  constructor() {
    super();
    this.state = {
      products: {}
    };
  }

  getListProducts = (products, flag) => {
    if (flag) {
      this.setState({ products: products.products });
    }
  };

  initialiceData = async () => {
    const config = await OdooConfig();
    const data = await Desencrypt();
    if (data) {
      const permiso = localStorage.getItem('Permission');
      if (permiso !== 'cobrador') {
        const odoo = new Odoo({
          url: config.host,
          port: config.port,
          db: config.database,
          username: data.user,
          password: data.password
        });

        setData(odoo, this.getListProducts, data);
      }
    }
  };

  componentDidMount = () => {
    this.initialiceData();
  };

  render() {
    return (
      <ToastProvider>
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
        />
        <style>
          {`.margen { min-height: 79.4vh; text-align: center; margin-top: 10px; min-width: 10vh; }`}
        </style>

        <HeaderDefault init={this.initialiceData} />
        <div className="margen" style={{ height: '100%', backgroundImage: `url(${fondo})` }}>
          <Routes products={this.state.products} />
        </div>
        <Footer />
      </ToastProvider>
    );
  }
}

// ✅ Este es el wrapper funcional que usa los hooks de React Router
const AppWithLandingRedirect = () => {
  const location = useLocation();
  const history = useHistory(); // <-- esto sí es correcto

  useEffect(() => {
    const currentPath = location.pathname;
    const landingActive = sessionStorage.getItem('landingActive') === 'true';

    if (currentPath.startsWith('/LandingPage')) {
      sessionStorage.setItem('landingActive', 'true');

      if (currentPath !== '/LandingPage/') {
        history.replace('/LandingPage/');
      }
    }

    if (landingActive && !currentPath.startsWith('/LandingPage')) {
      history.replace('/LandingPage/');
    }
  }, [location, history]);

  return <App />;
};


export default AppWithLandingRedirect;
